// extracted by mini-css-extract-plugin
module.exports = {"headerInner":"PageHeader_headerInner__3FAQ5","title":"PageHeader_title__fsPrA","timer":"PageHeader_timer__1M5T_"};